define.alias("shared/components/shared/video-player", "settings/components/shared/video-player");